/* tslint:disable */
/* eslint-disable */
/**
 * EMLINX API specification
 * This is API specification for EMLINX project.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { ErrorResponse } from '../models';
// @ts-ignore
import { ImportCasesRequest } from '../models';
// @ts-ignore
import { ImportCasesResponse } from '../models';
/**
 * ImportcasesApi - axios parameter creator
 * @export
 */
export const ImportcasesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Import Cases
         * @summary POST Import Cases
         * @param {ImportCasesRequest} [importCasesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCases: async (importCasesRequest?: ImportCasesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cases/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importCasesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImportcasesApi - functional programming interface
 * @export
 */
export const ImportcasesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImportcasesApiAxiosParamCreator(configuration)
    return {
        /**
         * Import Cases
         * @summary POST Import Cases
         * @param {ImportCasesRequest} [importCasesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importCases(importCasesRequest?: ImportCasesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importCases(importCasesRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ImportcasesApi.importCases']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ImportcasesApi - factory interface
 * @export
 */
export const ImportcasesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImportcasesApiFp(configuration)
    return {
        /**
         * Import Cases
         * @summary POST Import Cases
         * @param {ImportCasesRequest} [importCasesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCases(importCasesRequest?: ImportCasesRequest, options?: any): AxiosPromise<void> {
            return localVarFp.importCases(importCasesRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImportcasesApi - object-oriented interface
 * @export
 * @class ImportcasesApi
 * @extends {BaseAPI}
 */
export class ImportcasesApi extends BaseAPI {
    /**
     * Import Cases
     * @summary POST Import Cases
     * @param {ImportCasesRequest} [importCasesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportcasesApi
     */
    public importCases(importCasesRequest?: ImportCasesRequest, options?: RawAxiosRequestConfig) {
        return ImportcasesApiFp(this.configuration).importCases(importCasesRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

